module.exports = {
	"library.footer.terms_of_use": "Brugsbetingelser",
	"library.footer.terms_and_conditions": "Vilkår og betingelser",
	"library.footer.privacy_policy": "Fortrolighedspolitik",
	"library.footer.get_to_know_us": "Lær os at kende",
	"library.footer.about": "Om",
	"library.footer.jobs": "Job",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Få hjælp",
	"library.footer.find_events": "Find begivenheder",
	"library.footer.top_events": "Topbegivenheder",
	"library.footer.host_events": "Afhold begivenheder",
	"library.footer.become_a_host": "Bliv vært",
	"library.footer.tour": "Tur",
	"library.footer.embeddable_widgets": "Widgets, der kan indlejres",
	"library.footer.customers": "Kunder",
	"library.footer.pricing": "Priser",
	"library.footer.get_the_onsite_app": "Få appen, som kan bruges på stedet",
	"library.footer.developers": "Udviklere",
	"library.footer.contact_us": "Kontakt os"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/da.json
// module id = 1574
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16